window.openUrl = (url) => {
  const u = navigator.userAgent;
  const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isiOS) {   //ios终端
    window.location.href = url;
  } else {  // 其他终端
    window.open(url);
  }
}